import 'lib-flexible';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import store from '@/store';
import App from './pages/index';
import { NavProvider } from './contexts/NavContext';
import { ThemeProvider } from './contexts/ThemeContext';

// import 'antd/dist/antd.min.css';
import 'antd/dist/reset.css'
import './index.less';

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);
root.render(
  <ConfigProvider locale={zhCN}>
    <Provider store={store}>
      <ThemeProvider>
        <NavProvider>
          <App />
        </NavProvider>
      </ThemeProvider>
    </Provider>
  </ConfigProvider>
);